import {
  TextField,
  Avatar,
  Checkbox,
  RefreshIndicator,
} from 'material-ui';
import React, { PropTypes } from 'react';
import LoadingOverlay from '../tc-ui/loading-overlay';
import { countries } from '../../utils/select-fields';
import Select from 'react-select';
import { connect } from 'react-redux';
import { updateCompanyForContractingSignUp } from '../../stores/contracting-sign-up/actions';
import {
  compose,
} from 'ramda';
import SupplierPart from './form-part-supplier';
import { SmallFlatButton } from '../tc-ui/small-buttons';

const ContractingSignUpForm = props => {
  const {
    // selectExistingCompany,
    updateCountry,
    updateCompany,
    updatePassword,
    // updatePasswordConfirmation,
    updateProps,
    termsCheckedFn,
    contractingSignUp,
  } = props;

  const saving = contractingSignUp.get('saving');
  const companyType = contractingSignUp.get('companyType');
  // const selectCompany = compose(selectExistingCompany, pick(['companyName', 'companyId']));
  const selectedCompany = contractingSignUp.get('selectedCompany') ? contractingSignUp.get('selectedCompany').toJS() : null;
  const existingCompanyId = contractingSignUp.get('existingCompanyId');
  const foundExistingCompanyInfo = contractingSignUp.get('typeAheadCompanies') ? contractingSignUp.get('typeAheadCompanies').toJS() : [];
  return (
    <div>
      <div>
        <div style={{ display: 'flex', margin: '12px 0px 24px 0', alignItems: 'center' }}>
          <span style={{ width: '40%', marginRight: '12px', alignSelf: 'center' }}>
            Country
            <div style={{ fontSize: '12px', color: 'red' }}>* Required</div>
          </span>
          <div style={{ width: '100%' }}>
            <Select
              onChange={updateCountry}
              options={countries}
              value={contractingSignUp.get('country')}
              placeholder="Search And Pick A Country"
              clearable={false}
              scrollMenuIntoView={false}
              className="countrySelect"
            />
          </div>
          <RefreshIndicator
            size={30}
            left={10}
            top={5}
            style={{ position: 'relative' }}
          />
        </div>
        {
          existingCompanyId && selectedCompany ? (
            <div
              style={{
                maxHeight: '200px',
                overflowY: 'scroll',
                border: '1px solid #afaaaa',
                padding: '16px',
                backgroundColor: 'white',
              }}
            >
              <div className="flex-tc-sb" style={{ marginBottom: '8px' }}>
                <span>You are joining the company below.</span>
                <SmallFlatButton
                  style={{ border: '1px solid #00bcd4' }}
                  labelStyle={{ color: '#00bcd4', padding: '0 4px' }}
                  label="Change Company"
                  onTouchTap={() => updateProps({ selectedCompany: null, existingCompanyId: null, companyName: '' })}
                />
              </div>
              <div
                className="flex-center"
              >
                {
                  selectedCompany.profileImageUrl ? (
                    <Avatar src={selectedCompany.profileImageUrl}/>
                  ) : (<Avatar>{(selectedCompany.companyName || '')[0] || ''}</Avatar>)
                }
                <span style={{ marginLeft: '10px' }}>
                  <span style={{ fontWeight: '600' }}>{selectedCompany.companyName}</span>
                  <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}> - {selectedCompany.country}</span>
                </span>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', marginBottom: '12px', alignItems: 'baseline' }}>
              <span style={{ width: '40%', marginRight: '12px' }}>
                Company Name
                <div style={{ fontSize: '12px', color: 'red' }}>* Required</div>
              </span>
              <TextField
                data-cy="companyNameInput"
                hintText="Please enter your company name"
                filter={() => true}
                value={contractingSignUp.get('companyName')}
                underlineStyle={{ borderColor: 'rgba(0, 0, 0, 0.4)' }}
                onChange={(_, val) => updateCompany(val)}
                style={{ display: 'block', width: '100%' }}
              />
              <RefreshIndicator
                size={30}
                left={10}
                top={5}
                status={contractingSignUp.get('searchingCompany') ? 'loading' : 'hide'}
                style={{ position: 'relative' }}
              />
            </div>
          )
        }
        {
          contractingSignUp.get('showFoundExistingCompanyInfo') &&
          Array.isArray(foundExistingCompanyInfo) &&
          foundExistingCompanyInfo.length > 0 ?
            <div style={{ marginTop: '16px' }}>
              <span>{'Continue entering your company name to create a new account.'}</span>
              <div style={{ textAlign: 'center', fontWeight: 'bold' }}>OR</div>
              <div
                style={{
                  maxHeight: '200px',
                  overflowY: 'scroll',
                  border: '1px solid #afaaaa',
                  padding: '16px',
                  backgroundColor: 'white',
                }}
              >
                <span>{'Select your company below to be added to an existing account.'}</span>
                <br/>
                {
                  foundExistingCompanyInfo.map((existingCompany, i, arr) => {
                    return (
                      <div
                        key={i}
                        className="flex-tc-sb"
                        style={{ backgroundColor: '#f4f6fa', padding: '8px', borderBottom: i < arr.length - 1 ? '1px solid #cacdd4' : '' }}
                      >
                        <div className="flex-center">
                          {
                            existingCompany.profileImageUrl ? (
                              <Avatar src={existingCompany.profileImageUrl}/>
                            ) : (<Avatar>{(existingCompany.companyName || '')[0] || ''}</Avatar>)
                          }
                          <span style={{ marginLeft: '10px' }}>
                          <span style={{ fontWeight: '600' }}>{existingCompany.companyName}</span>
                          <span style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '14px' }}> - {existingCompany.country}</span>
                        </span>
                        </div>
                        <SmallFlatButton
                          style={{ border: '1px solid #00bcd4' }}
                          labelStyle={{ color: '#00bcd4', padding: '8px' }}
                          label="Join"
                          onTouchTap={() => updateProps({
                            selectedCompany: existingCompany,
                            companyName: existingCompany.companyName,
                            existingCompanyId: existingCompany.companyId,
                            showFoundExistingCompanyInfo: false,
                          })}
                        />
                      </div>
                    );
                  })
                }
              </div>
            </div>
            : <span/>
        }
        <div style={{ display: 'flex', marginBottom: '24px', alignItems: 'baseline' }}>
          <span style={{ width: '40%', marginRight: '12px' }}>
            Email
            <div style={{ fontSize: '12px', color: 'red' }}>* Required</div>
          </span>
          <TextField
            id="email"
            disabled={contractingSignUp.get('preconfirmed')}
            onChange={(_, val) => updateProps({ email: val })}
            data-cy="email"
            hintText="Please enter your email"
            underlineStyle={{ borderColor: 'rgba(0, 0, 0, 0.4)' }}
            value={contractingSignUp.get('email')}
            style={{ display: 'block', width: '100%' }}
          />
          <RefreshIndicator
            size={30}
            left={10}
            top={5}
            style={{ position: 'relative' }}
          />
        </div>
        <div style={{ display: 'flex', margin: '12px 0px', alignItems: 'baseline' }}>
          <span style={{ width: '40%', marginRight: '12px', alignSelf: 'center' }}>
            Password
            <div style={{ fontSize: '12px', color: 'red' }}>* Required</div>
          </span>
          <TextField
            data-cy="passwordInput"
            hintText="Please enter your password"
            type="password"
            id="password"
            value={contractingSignUp.get('password')}
            underlineStyle={{ borderColor: 'rgba(0, 0, 0, 0.4)' }}
            onChange={updatePassword}
            style={{ display: 'block', width: '100%' }}
          />
          <RefreshIndicator
            size={30}
            left={10}
            top={5}
            style={{ position: 'relative' }}
          />
        </div>
        {
          companyType === 'Supplier' && !existingCompanyId && <SupplierPart {...contractingSignUp.toJS()} updateProps={updateProps} />
        }
        {/* <div style={{ display: 'flex', margin: '12px 0px' }}>
           <span style={{ width: '40%', marginRight: '12px', alignSelf: 'center' }}>Confirm password</span>
           <TextField
           hintText="Please enter your password"
           type="password"
           value={contractingSignUp.get('confirmPassword')}
           onChange={updatePasswordConfirmation}
           style={{ display: 'block', width: '100%', margin: '8px 0px' }}
           errorText={contractingSignUp.get('confirmPasswordError') ? 'Passwords Do Not Match' : ''}
           />
           </div>*/}
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '30px', whiteSpace: 'pre-wrap', alignItems: 'center' }}>
          <Checkbox
            style={{ width: '24px' }}
            onCheck={termsCheckedFn}
            checked={contractingSignUp.get('termsAccepted')}
            data-cy="iAgreeCheckBox"
          />
          <span>I agree to the </span><a target="_blank" href="http://www.tourconnect.com/terms-of-service/">Terms and Conditions</a>
        </div>
      </div>
      <LoadingOverlay loading={saving} />
    </div>
  );
};

ContractingSignUpForm.propTypes = {
  updatePassword: PropTypes.func.isRequired,
  updateCompany: PropTypes.func.isRequired,
  updatePasswordConfirmation: PropTypes.func.isRequired,
  updateCountry: PropTypes.func.isRequired,
  selectExistingCompany: PropTypes.func.isRequired,
  contractingSignUp: PropTypes.object.isRequired,
  termsCheckedFn: PropTypes.func,
  companyType: PropTypes.string,
  productType: PropTypes.string,
  saving: PropTypes.bool,
  updateProps: PropTypes.func,
};

const mapStateToProps = ({ contractingSignUp }) => {
  return {
    contractingSignUp,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    updateCompany: compose(dispatch, updateCompanyForContractingSignUp),
    updateCountry: ({ value }) => dispatch({ type: 'UPDATE_CONTRACTING_SIGN_UP_COUNTRY', payload: value }),
    updatePassword: ({ target: { value } }) => dispatch({ type: 'UPDATE_CONTRACTING_SIGN_UP_PASSWORD', payload: value }),
    updatePasswordConfirmation: ({ target: { value } }) => dispatch({ type: 'UPDATE_CONTRACTING_SIGN_UP_PASSWORD_CONFIRMATION', payload: value }),
    selectExistingCompany: (value) => dispatch({ type: 'UPDATE_RESOURCE_ID', payload: value }),
    termsCheckedFn: () => dispatch({ type: 'CONTRACTING_SIGN_UP_TERMS_CHECKED' }),
    updateProps: payload => dispatch({ type: 'UPDATE_PROPS_FOR_SHELL_ACCOUNT_SIGNUP', payload }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContractingSignUpForm);



// WEBPACK FOOTER //
// ./src/app/components/contracting-sign-up/signup-form.jsx